import { component } from 'picoapp';
import { isEmpty } from '../utils';

export default component((node, ctx) => {

  if (isEmpty(site.GOOGLE_MAPS_KEY)) {
    console.warn('GOOGLE_MAPS_KEY not set');
    return;
  }

  function init() {

    const map = new google.maps.Map(node, {
      center: {lat: 44.880308, lng: -93.328723},
      zoom: 15,
      mapTypeControl: false,
      zoomControl: true,
      streetViewControl: false,
      fullscreenControl: false,
      styles
    });

    new window.google.maps.Marker({
        map,
        position: {lat: 44.8799813, lng: -93.3308399},
        title: 'Beyer Family Law',
        icon: `${site.dir}/images/map-marker.svg`
      })
      .addListener('click', () => {
        const destination = encodeURIComponent('6800 France Ave S #125 Edina, MN 55435');
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${destination}`);
      });
  }

  const script = document.createElement('script');
  script.onload = init;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${site.GOOGLE_MAPS_KEY}`;
  document.body.appendChild(script);

});

const styles = [{
  "featureType": "all",
  "stylers": [{
    "saturation": 0
  }, {
    "hue": "#e7ecf0"
  }]
}, {
  "featureType": "road",
  "stylers": [{
    "saturation": -70
  }]
}, {
  "featureType": "transit",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "water",
  "stylers": [{
    "visibility": "simplified"
  }, {
    "saturation": -60
  }]
}];
